import { SetupIntent } from '@arcadiapower/shrike';
import { capitalize } from '@arcadiapower/warbler';

export interface SetupIntentDetails {
  paymentMethod: {
    lastFour: string;
    source: string;
    type: 'credit_card' | Omit<string, 'credit_card'>;
  };
}

export const paymentMethodFromSetupIntent = (setupIntent: SetupIntent): SetupIntentDetails => {
  const paymentMethod: SetupIntentDetails['paymentMethod'] = {
    lastFour: '',
    source: '',
    type: '',
  };

  const stripePaymentMethod = setupIntent?.payment_method;

  if (!stripePaymentMethod) {
    return { paymentMethod };
  }

  switch (typeof stripePaymentMethod) {
    // The Shrike `PaymentMethodForm` normally expands the `payment_method` field to a full
    // `PaymentMethod` object, but Cash App support is still a beta feature so this
    // is not happening as expected.
    case 'string': {
      paymentMethod.source = 'Cash App Pay';
      return { paymentMethod };
    }

    case 'object': {
      // Explicitly checking for the payment_method type is better but this currently
      // doesn't work for the same reason as above.
      // It's not clear when Stripe will implement this so this is a defense against
      // the feature suddenly breaking.
      // Once this is fixed, we can remove the `typeof stripePaymentMethod === 'string'` check.
      if (stripePaymentMethod.type === 'cashapp') {
        paymentMethod.source = 'Cash App Pay';
        return { paymentMethod };
      }

      const item = stripePaymentMethod.card || stripePaymentMethod.us_bank_account;

      // @ts-expect-error Property 'brand' does not exist on type 'UsBankAccount'
      const source = item?.brand ? capitalize(item?.brand) : `${item?.bank_name} account`;

      // @ts-expect-error Property 'last4' does not exist on type 'UsBankAccount'
      paymentMethod.lastFour = item?.last4;
      paymentMethod.source = source;
      paymentMethod.type =
        stripePaymentMethod.type === 'card' ? 'credit_card' : stripePaymentMethod.type;

      return { paymentMethod };
    }
  }
};
